module.exports = __webpack_public_path__ + "static/media/mobile_mockup_3.d76cbed8.png";